import {
  HUB_ENTER_FILL_FRAMES,
  HUB_ENTER_FILL_LOCK_LEAD_MS,
} from "@story/data-centers-hub/config/intro";

type Args = {
  wipeMs: number;
  setFillPin: (next: boolean) => void;
  /** Omit for hosts that only need the early clip pin (e.g. ScrollBallast). */
  setFillLock?: (next: boolean) => void;
};

/**
 * After enter `open` flips: latch `data-hub-fill` once the animation has
 * attached, then `data-hub-fill-lock` near wipe-end. Returns a cancel fn for
 * effect cleanup.
 */
export function scheduleEnterFillPins({
  wipeMs,
  setFillPin,
  setFillLock,
}: Args): () => void {
  let raf = 0;
  let lockTimer = 0;
  let frames = 0;
  const tick = () => {
    frames += 1;
    if (frames < HUB_ENTER_FILL_FRAMES) {
      raf = requestAnimationFrame(tick);
      return;
    }
    setFillPin(true);
  };
  raf = requestAnimationFrame(tick);
  if (setFillLock) {
    lockTimer = window.setTimeout(() => {
      setFillLock(true);
    }, Math.max(0, wipeMs - HUB_ENTER_FILL_LOCK_LEAD_MS));
  }
  return () => {
    cancelAnimationFrame(raf);
    window.clearTimeout(lockTimer);
  };
}
